import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import Index from "./pages/Index.tsx";
import CookieConsent from "./components/CookieConsent.tsx";
import ScrollToTop from "./components/ScrollToTop.tsx";
import StickyQuoteCTA from "./components/StickyQuoteCTA.tsx";
import TodayQuoteBar from "./components/TodayQuoteBar.tsx";
import { VisitTracker } from "./hooks/useVisitTracking.ts";


/* Route pages load on demand so the homepage ships a small bundle. */
const Careers = lazy(() => import("./pages/Careers.tsx"));
const ProductDetail = lazy(() => import("./pages/ProductDetail.tsx"));
const LocationPage = lazy(() => import("./pages/LocationPage.tsx"));
const Blog = lazy(() => import("./pages/Blog.tsx"));
const BlogPost = lazy(() => import("./pages/BlogPost.tsx"));
const MarketingAgent = lazy(() => import("./pages/MarketingAgent.tsx"));
const SteelPrice = lazy(() => import("./pages/SteelPrice.tsx"));
const CityProduct = lazy(() => import("./pages/CityProduct.tsx"));
const LinkedInPostGenerator = lazy(() => import("./pages/LinkedInPostGenerator.tsx"));
const Promo = lazy(() => import("./pages/Promo.tsx"));
const ThankYou = lazy(() => import("./pages/ThankYou.tsx"));
const SeoDashboard = lazy(() => import("./pages/SeoDashboard.tsx"));
const Login = lazy(() => import("./pages/Login.tsx"));
const OAuthConsent = lazy(() => import("./pages/OAuthConsent.tsx"));
const AdminSetup = lazy(() => import("./pages/AdminSetup.tsx"));
const ZolotoValvesPriceList = lazy(() => import("./pages/ZolotoValvesPriceList.tsx"));
const TataPipesPriceList = lazy(() => import("./pages/TataPipesPriceList.tsx"));
const GiPipePriceList = lazy(() => import("./pages/GiPipePriceList.tsx"));
const SupplierDirectory = lazy(() => import("./pages/SupplierDirectory.tsx"));
const DeliveryMap = lazy(() => import("./pages/DeliveryMap.tsx"));
const CityFaq = lazy(() => import("./pages/CityFaq.tsx"));
const LocalPack = lazy(() => import("./pages/LocalPack.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));

const App = () => (
  <>
    <Toaster />
    <BrowserRouter>
        <ScrollToTop />
        <VisitTracker />
        <Suspense fallback={<div className="min-h-screen" />}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/locations/:slug" element={<LocationPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/marketing-agent" element={<MarketingAgent />} />
          <Route path="/steel-price-today" element={<SteelPrice />} />
          <Route path="/suppliers" element={<SupplierDirectory />} />
          <Route path="/delivery-map" element={<DeliveryMap />} />
          <Route path="/faq/:city" element={<CityFaq />} />
          <Route path="/branches" element={<LocalPack />} />
          <Route path="/supplier/:combo" element={<CityProduct />} />
          <Route path="/linkedin-post-generator" element={<LinkedInPostGenerator />} />
          <Route path="/promo" element={<Promo />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/seo-dashboard" element={<SeoDashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
          <Route path="/admin-setup" element={<AdminSetup />} />
          <Route path="/price-lists/zoloto-valves" element={<ZolotoValvesPriceList />} />
          <Route path="/price-lists/tata-pipes" element={<TataPipesPriceList />} />
          <Route path="/price-lists/gi-pipe-price-per-kg" element={<GiPipePriceList />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
        <CookieConsent />
        <StickyQuoteCTA />
        <TodayQuoteBar />
    </BrowserRouter>
  </>
);

export default App;
